import { render, staticRenderFns } from "./notifySetting.vue?vue&type=template&id=10b325d0&scoped=true"
import script from "./notifySetting.vue?vue&type=script&lang=js"
export * from "./notifySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10b325d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10b325d0')) {
      api.createRecord('10b325d0', component.options)
    } else {
      api.reload('10b325d0', component.options)
    }
    module.hot.accept("./notifySetting.vue?vue&type=template&id=10b325d0&scoped=true", function () {
      api.rerender('10b325d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/socialComponent/notifySetting.vue"
export default component.exports